import React from "react";
import { Modal } from "antd";

const ProductCenterModal = ({
  showProdCenterModal,
  setShowProdCenterModal,
  prodItem,
  productionCentersOptions,
  cart,
  setCart,
}) => {
  if (!showProdCenterModal || !prodItem) return null;

  return (
    <Modal
      open={showProdCenterModal}
      onCancel={() => setShowProdCenterModal(false)}
      footer={null}
      centered
      closable={true}
      maskClosable={true}
      width={420}
      styles={{ body: {
        padding: "20px",
        background: "#ffffff",
        height: "380px",
      } }}
      className="production-center-modal"
      title={
        <span
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            maxWidth: "320px",
          }}
          title={prodItem.name}
        >
          Production Centre for {prodItem.name}
        </span>
      }
    >
      <div
        style={{
          height: "100%",
          overflowY: "scroll",
          paddingRight: "4px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "12px",
          }}
        >
          {productionCentersOptions.map((pc) => (
            <div
              key={pc.value}
              onClick={() => {
                const updatedItems = cart.items.map((i) => (i.lineId === prodItem.lineId ? { ...i, productionCenterId: pc.value, productionCenter: pc.label } : i));
                setCart({ ...cart, items: updatedItems });
                setShowProdCenterModal(false);
              }}
              style={{
                border: prodItem.productionCenterId === pc.value ? "2px solid #f3f4f9" : "1px solid #d9d9d9",
                background: prodItem.productionCenterId === pc.value ? "#9fa4ae" : "#ffffff",
                padding: "16px 0",
                borderRadius: "12px",
                textAlign: "center",
                cursor: "pointer",
                fontSize: "1rem",
                fontWeight: 500,
                color: "#0F0718",
                transition: "all 0.2s",
              }}
            >
              {pc.label}
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default ProductCenterModal;
